import { InstitutionalFlowChart } from "@/cockpit/shadow/InstitutionalFlowChart";
import { InsiderScatterPlot } from "@/cockpit/shadow/InsiderScatterPlot";
import { PoliticalFlowTimeline } from "@/cockpit/shadow/PoliticalFlowTimeline";
import { DilutionPressureLine } from "@/cockpit/shadow/DilutionPressureLine";
import { SentimentFeedTable } from "@/cockpit/talk/SentimentFeedTable";
import { mapTalkDoc } from "@/cockpit/mapHouseFeed";

/** Dev-only layout fixture so charts can be watched without a Clerk session. */
const HOLDERS = [
  { investorName: "Vanguard Group", positionValueUsd: 18.4e9, shares: 42.1e6, newPositionUsd: 0, exitUsd: 0, periodOfReport: "2026-06-30" },
  { investorName: "BlackRock", positionValueUsd: 14.1e9, shares: 32.4e6, newPositionUsd: 0, exitUsd: 0, periodOfReport: "2026-06-30" },
  { investorName: "State Street", positionValueUsd: 7.2e9, shares: 16.5e6, newPositionUsd: 0, exitUsd: 0, periodOfReport: "2026-06-30" },
  { investorName: "Fidelity", positionValueUsd: 3.8e9, shares: 8.7e6, newPositionUsd: 0, exitUsd: 0, periodOfReport: "2026-06-30" },
];

const INSIDER = [
  { date: "2026-08-04", valueUsd: 2.4e6, shares: 18000, type: "Buy", insiderName: "A. Buyer" },
  { date: "2026-08-12", valueUsd: 6.1e6, shares: 42000, type: "Sell", insiderName: "B. Seller" },
  { date: "2026-08-19", valueUsd: 1.1e6, shares: 8000, type: "Buy", insiderName: "C. Officer" },
  { date: "2026-08-27", valueUsd: 9.4e6, shares: 61000, type: "Sell", insiderName: "D. Director" },
  { date: "2026-09-02", valueUsd: 3.2e6, shares: 21000, type: "Buy", insiderName: "A. Buyer" },
];

const PTR = [
  { politicianName: "Jane Legislator", party: "", chamber: "Senate", type: "Buy", amountMidpointUsd: 175000, delayFlag: false, delayDays: 0 },
  { politicianName: "Jane Legislator", party: "", chamber: "Senate", type: "Sell", amountMidpointUsd: 75000, delayFlag: false, delayDays: 0 },
  { politicianName: "John Representative", party: "", chamber: "House", type: "Sell", amountMidpointUsd: 75000, delayFlag: false, delayDays: 0 },
];

const SALES = [
  { id: "144-1", date: "2026-07-18", seller: "Affiliate A", shares: 120000, marketValueUsd: 4.8e6 },
  { id: "144-2", date: "2026-08-09", seller: "Affiliate B", shares: 80000, marketValueUsd: 3.1e6 },
  { id: "144-3", date: "2026-08-28", seller: "Affiliate C", shares: 45000, marketValueUsd: 1.7e6 },
];

const TALK = mapTalkDoc({
  ticker: "TEST",
  items: [
    { date: "2026-09-01", headline: "Company beats estimates on services revenue" },
    { date: "2026-09-02", headline: "Shares plunge after the company misses estimates" },
    { date: "2026-09-03", headline: "Board reiterates full-year unit guidance" },
    { date: "2026-09-04", headline: "CEO faces lawsuit over disclosure timing" },
    { date: "2026-09-05", headline: "Supplier notes a two-week production pause at one assembly line" },
  ],
});

export default function CockpitPreviewPage() {
  return (
    <div
      className="min-h-screen p-4 md:p-6 max-w-[1400px] mx-auto space-y-3"
      style={{ background: "var(--hoip-bg)", color: "var(--hoip-text-primary)" }}
      data-testid="cockpit-preview-page"
    >
      <p className="text-[11px]" style={{ color: "var(--hoip-text-tertiary)" }}>
        Dev layout fixture — not live house-feed.
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <InstitutionalFlowChart flows={[]} holders={HOLDERS} note="" />
        <InsiderScatterPlot activity={INSIDER} buyCount30d={3} sellCount30d={2} />
        <PoliticalFlowTimeline timeline={[]} trades={PTR} />
        <DilutionPressureLine sales={SALES} dataSourceStatus="fdn-mongo" />
      </div>
      <SentimentFeedTable feed={TALK.feed} houseFeed />
    </div>
  );
}
